import {
	PropsWithChildren,
	ReactElement,
	useState
} from "react";
import styles from "./DocumentNameWithQuickActions.module.less";
import { ActionAndOthers } from "client_legacy/ndaw/actions";
import { QuickActions } from "client/Components";

export type DocumentNameWithQuickActionsProps<TActionContext> = {
	selectionActions: readonly (ActionAndOthers<TActionContext> & { quickActionIndex?: number; })[];
	maxActionCount?: number;
	actionContext: TActionContext;
	isTouch: boolean;
	isSelected: boolean;
	isRowHovered: boolean;
	name: string;
};

export const DocumentNameWithQuickActions = <TActionContext,>(props: PropsWithChildren<DocumentNameWithQuickActionsProps<TActionContext>>): ReactElement => {
	const {
		selectionActions,
		maxActionCount = 2,
		actionContext,
		isTouch,
		isSelected,
		isRowHovered,
		name,
		children
	} = props;

	const [isMoreActionsOpen, setIsMoreActionOpen] = useState<boolean>(false);

	return(
		<div className={styles.root}>
			<div className={styles.documentNameContainer}>
				{children}
			</div>
			{(
				isRowHovered
				|| isSelected
				|| isMoreActionsOpen
				|| isTouch
				) && (
					<span>
						<QuickActions
							actions={selectionActions}
							actionContext={actionContext}
							isTouch={isTouch}
							isMoreActionsOpen={isMoreActionsOpen}
							onIsMoreActionOpenChange={setIsMoreActionOpen}
							maxActionCount={maxActionCount}
							menuTitle={name}
						/>
					</span>
			)}
		</div>
	);
};
DocumentNameWithQuickActions.displayName = "DocumentNameWithQuickActions";